import {
	INTEGRATION_APP_CATEGORIES,
	type IntegrationAppCategory,
	MAX_INTEGRATION_APP_CATEGORIES,
} from "@repo/shared-primitives"
import { Button } from "@/components/ui/button"
import { cn } from "@/utils/styles.helpers"

export const INTEGRATION_APP_CATEGORY_LABELS: Record<
	IntegrationAppCategory,
	string
> = {
	inventory: "Inventory management",
	multichannel: "Multichannel selling",
	pricing: "Pricing & repricing",
	collection: "Collection tracking",
	"deck-building": "Deck building",
	scanning: "Card scanning",
	shipping: "Shipping & fulfilment",
	"point-of-sale": "Point of sale",
	analytics: "Analytics & reporting",
	accounting: "Accounting & tax",
	community: "Community & content",
}

interface CategoryPickerProps {
	value: IntegrationAppCategory[]
	onChange: (categories: IntegrationAppCategory[]) => void
	disabled?: boolean
	className?: string
}

/**
 * Toggle chips over the directory categories. Unselected chips are disabled
 * once `MAX_INTEGRATION_APP_CATEGORIES` are picked.
 */
export function CategoryPicker({
	value,
	onChange,
	disabled,
	className,
}: CategoryPickerProps) {
	const atLimit = value.length >= MAX_INTEGRATION_APP_CATEGORIES

	function toggle(category: IntegrationAppCategory) {
		if (value.includes(category)) {
			onChange(value.filter((entry) => entry !== category))
			return
		}

		onChange(
			INTEGRATION_APP_CATEGORIES.filter(
				(entry) => entry === category || value.includes(entry),
			),
		)
	}

	return (
		<div className={cn("flex flex-wrap gap-2", className)}>
			{INTEGRATION_APP_CATEGORIES.map((category) => {
				const selected = value.includes(category)

				return (
					<Button
						key={category}
						type="button"
						size="sm"
						variant={selected ? "default" : "outline"}
						disabled={disabled || (atLimit && !selected)}
						aria-pressed={selected}
						onClick={() => toggle(category)}
						className="h-7 px-2.5 text-xs"
					>
						{INTEGRATION_APP_CATEGORY_LABELS[category]}
					</Button>
				)
			})}
		</div>
	)
}
